<!--
/*******************************************************************************
*@ 컴포넌트명   : aucManagePayees.vue
*@ 컴포넌트설명 : 오클랜드 타행 자주쓰는계좌등록
*@ 사용전문     : RBF0600C60 - 입출금계좌등록
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div :class="usePage != 'autoTransfer' ?'scroll':''">
    <article :class="usePage != 'autoTransfer' ?'contents':''">
      <div :class="usePage != 'autoTransfer' ?'form':''">
        <!-- <div :class="usePage != 'autoTransfer' ?'form-row':''">
          <input-text
            v-if="usePage != 'autoTransfer'"
            ref="bnkEngName"
            id="bnkEngName"
            :value.sync="bnkEngName"
            labelI18n="MPRS-02-02-16-03"
            :maxByte="50"
            engCase5
          />
        </div>-->
        <div class="form-row">
          <div class="item-tit" v-if="usePage == 'autoTransfer'">
            {{/*입금 계좌번호*/$t("MPRS-02-02-16-02")}}
            <sup class="point">*</sup>
          </div>
          <div class="item-tit" v-else>
            {{/*계좌번호*/$t("MPRS-02-02-09-04")}}
            <sup class="point">*</sup>
          </div>
          <div class="form-text-field">
            <div class="input-text-field group">
              <input
                ref="acno1"
                type="tel"
                id="acno1"
                maxlength="2"
                class="form-control"
                v-model="acno1"
                @keyup="autoFocus1"
              />
              <input
                ref="acno2"
                type="tel"
                id="acno2"
                maxlength="4"
                class="form-control"
                v-model="acno2"
                @keyup="autoFocus2"
              />
              <input
                ref="acno3"
                type="tel"
                id="acno3"
                maxlength="7"
                class="form-control"
                v-model="acno3"
                @keyup="autoFocus3"
              />
              <input
                ref="acno4"
                type="tel"
                id="acno4"
                maxlength="2"
                class="form-control"
                v-model="acno4"
              />
            </div>
          </div>
          <div class="info info-etc">※ {{ $t("MPRS-02-02-19-03")}}</div>
          <div class="info info-etc" v-html="$t('MPRS-02-02-09-12', { 1: cncycd })"></div>
        </div>
        <div class="form-row">
          <input-text
            v-if="usePage != 'autoTransfer'"
            ref="inquryDpstrName"
            id="inquryDpstrName"
            :value.sync="inquryDpstrName"
            labelI18n="MPRS-02-02-19-05"
            placeholder="MPRS-02-02-09-06"
            required
            engCase5
            :maxByte="70"
          />
        </div>
        <div class="form-row" v-if="usePage=='manage'">
          <input-text
            ref="inquryAcnAls"
            id="inquryAcnAls"
            :value.sync="inquryAcnAls"
            labelI18n="MPRS-02-02-19-07"
            placeholder="MPRS-02-02-09-08"
            required
            :maxByte="40"
            engCase5
          />
          <!-- <div
            class="info info-etc"
          >{{ /*※ 계좌별명은 영문기준 최대 12자리까지 입력 가능합니다.*/ $t("MPRS-02-02-15-14") }}</div>-->
        </div>
      </div>
      <div class="btn-area--full fixed">
        <button class="btn md gray" @click="goToPrev()">{{ /*뒤로*/ $t("MPRS-02-02-15-12") }}</button>
        <button
          class="btn md normal"
          @click="goToNext()"
          :class="prgsYN"
        >{{ /*다음*/ $t("MPRS-02-02-15-13") }}</button>
      </div>
    </article>
    <modal-pop :opened.sync="modalOpend" confirm="MCOM-0000003">
      <template #content>{{modalMessage}}</template>
    </modal-pop>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: {
    usePage: {
      type: String,
    },
    cncycd: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapFields(["sessionInfo"]),
    ...mapFields("transfer/autoTrsaccInfoInpt", ["mnrcvAcno"]),
  },
  watch: {
    acno1: function () {
      this.validPrgs();
      //return (this.acno1 = this.acno1.replace(/[^0-9]/g, ""));
    },
    acno2: function () {
      this.validPrgs();
      //return (this.acno2 = this.acno2.replace(/[^0-9]/g, ""));
    },
    acno3: function () {
      this.validPrgs();
      //return (this.acno3 = this.acno3.replace(/[^0-9]/g, ""));
    },
    acno4: function () {
      this.validPrgs();
      //return (this.acno4 = this.acno4.replace(/[^0-9]/g, ""));
    },
    // bnkEngName: function () {
    //   this.validPrgs();
    // },
    inquryDpstrName: function () {
      this.validPrgs();
    },
    inquryAcnAls: function () {
      this.validPrgs();
    },
  },
  mounted() {
    if (!_.isEmpty(this.mnrcvAcno)) {
      this.setText(this.mnrcvAcno);
    }
  },
  data() {
    return {
      acno1: undefined,
      acno2: undefined,
      acno3: undefined,
      acno4: undefined,
      modalMessage: "",
      modalOpend: false,
      // bnkEngName: "",
      inquryAcno: "",
      inquryDpstrName: "",
      inquryAcnAls: "",
      RBF0600C60: {
        request: {},
        response: {},
      },
      mnrcvInfo: {
        mnrcvAcnAls: "",
        mnrcvAcno: "",
        mnrcvCncycd: "",
        mnrcvDpstrName: "",
        mnrcvOthrBnkName: "",
        mnrcvSerno: "",
        rcevnBnkIfscCode: "",
        mnrcvBrnName: "",
      },
      validList: [],
      prgsYN: "disabled",
    };
  },
  methods: {
    autoFocus1() {
      if (!_.isEmpty(this.acno1)) {
        if (this.acno1.length == 2) {
          document.getElementById("acno2").focus();
        }
      }
    },
    autoFocus2() {
      if (!_.isEmpty(this.acno2)) {
        if (this.acno2.length == 4) {
          document.getElementById("acno3").focus();
        }
      }
    },
    autoFocus3() {
      if (!_.isEmpty(this.acno3)) {
        if (this.acno3.length == 7 && !_.isEmpty(this.acno3)) {
          document.getElementById("acno4").focus();
        }
      }
    },
    validPrgs() {
      if (this.usePage == "manage") {
        if (
          // this.$refs.bnkEngName != undefined &&
          this.$refs.acno1 != undefined &&
          this.$refs.acno2 != undefined &&
          this.$refs.acno3 != undefined &&
          this.$refs.acno4 != undefined &&
          this.$refs.inquryDpstrName != undefined &&
          this.$refs.inquryAcnAls != undefined
        ) {
          this.prgsYN =
            // this.$refs.bnkEngName.$v.$invalid ||
            this.$refs.inquryDpstrName.$v.$invalid ||
            this.$refs.inquryAcnAls.$v.$invalid ||
            _.isEmpty(this.acno1) ||
            _.isEmpty(this.acno2) ||
            _.isEmpty(this.acno3) ||
            _.isEmpty(this.acno4)
              ? "disabled"
              : "";
          this.$EventBus.$emit("aucRegister", this.prgsYN);
        } else {
          this.prgsYN = "";
          this.$EventBus.$emit("aucRegister", this.prgsYN);
        }
      } else {
        if (
          // this.$refs.bnkEngName != undefined &&
          this.$refs.acno1 != undefined &&
          this.$refs.acno2 != undefined &&
          this.$refs.acno3 != undefined &&
          this.$refs.acno4 != undefined &&
          this.$refs.inquryDpstrName != undefined
        ) {
          this.prgsYN =
            // this.$refs.bnkEngName.$v.$invalid ||
            this.$refs.inquryDpstrName.$v.$invalid || _.isEmpty(this.acno1) || _.isEmpty(this.acno2) || _.isEmpty(this.acno3) || _.isEmpty(this.acno4) ? "disabled" : "";
          this.$EventBus.$emit("aucRegister", this.prgsYN);
        } else {
          this.prgsYN = "";
          this.$EventBus.$emit("aucRegister", this.prgsYN);
        }
      }
    },
    setInfo() {
      this.inquryAcno = "";
      this.inquryAcno = this.inquryAcno.concat(this.acno1, this.acno2, this.acno3, this.acno4);
      if (this.usePage != "autoTransfer") {
        this.mnrcvInfo = {
          mnrcvAcnAls: "",
          mnrcvAcno: this.inquryAcno,
          mnrcvCncycd: this.cncycd,
          mnrcvDpstrName: this.inquryDpstrName,
          // mnrcvOthrBnkName: this.bnkEngName,
          mnrcvOthrBnkName: "",
          mnrcvSerno: "",
          rcevnBnkIfscCode: "",
          mnrcvBrnName: "",
        };
        return this.mnrcvInfo;
      } else {
        // this.mnrcvInfo.acno = this.inquryAcno;
        this.mnrcvInfo = {
          acno: this.inquryAcno,
          mnrcvCncycd: this.cncycd,
        };
      }
    },
    goToPrev() {
      this.$router.push({ name: "managePayeesList", params: { currentTab: 1 } });
    },
    valid() {
      if (this.usePage != "autoTransfer") {
        if (this.usePage == "manage") {
          this.$refs.inquryAcnAls.$v.$touch();
        }

        this.$refs.inquryDpstrName.$v.$touch();
        // this.$refs.bnkEngName.$v.$touch();
        if (this.usePage == "manage") {
          // if (this.$refs.inquryAcnAls.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.bnkEngName.$v.$invalid) {
          if (this.$refs.inquryAcnAls.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid) {
            return false;
          }
        } else {
          // if (this.$refs.inquryDpstrName.$v.$invalid || this.$refs.bnkEngName.$v.$invalid) {
          if (this.$refs.inquryDpstrName.$v.$invalid) {
            return false;
          }
        }
      }
      // this.validList = Object.keys(this.$refs);
      // for (let i = 0; i < this.validList.length; i++) {
      //   this.$refs[this.validList[i]].$v.$touch();
      // }
      // for (let i = 0; i < this.validList.length; i++) {
      //   if (this.$refs[this.validList[i]].$v.$invalid) {
      //     return false;
      //   }
      // }
      if (this.acno1 == "" || this.acno1 == null) {
        this.modalMessage = this.$t("MPRS-02-02-15-15", { 1: this.$t("MPAY-02-01-25-09") });
        this.modalOpend = true;
        return false;
      }
      if (this.acno2 == "" || this.acno2 == null) {
        this.modalMessage = this.$t("MPRS-02-02-15-15", { 1: this.$t("MPAY-02-01-25-09") });
        this.modalOpend = true;
        return false;
      }
      if (this.acno3 == "" || this.acno3 == null) {
        this.modalMessage = this.$t("MPRS-02-02-15-15", { 1: this.$t("MPAY-02-01-25-09") });
        this.modalOpend = true;
        return false;
      }
      if (this.acno4 == "" || this.acno4 == null) {
        this.modalMessage = this.$t("MPRS-02-02-15-15", { 1: this.$t("MPAY-02-01-25-09") });
        this.modalOpend = true;
        return false;
      }
      if (this.acno1.length + this.acno2.length + this.acno3.length + this.acno4.length != 15) {
        this.modalMessage = this.$t("MPRS-02-02-15-16", { 1: this.$t("MPAY-02-01-25-09") });
        this.modalOpend = true;
        return false;
      }
      return true;
    },
    goToNext() {
      // this.$refs.inquryAcnAls.$v.$touch();
      // this.$refs.inquryDpstrName.$v.$touch();
      // this.$refs.bnkEngName.$v.$touch();
      // if (this.$refs.inquryAcnAls.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.bnkEngName.$v.$invalid) {
      //   return;
      // }
      // if (this.acno1 == "" || this.acno1 == null) {
      //   this.modalMessage = this.$t("MPRS-02-02-15-15", { 1: this.$t("MPAY-02-01-25-09") });
      //   this.modalOpend = true;
      //   return;
      // }
      // if (this.acno2 == "" || this.acno2 == null) {
      //   this.modalMessage = this.$t("MPRS-02-02-15-15", { 1: this.$t("MPAY-02-01-25-09") });
      //   this.modalOpend = true;
      //   return;
      // }
      // if (this.acno3 == "" || this.acno3 == null) {
      //   this.modalMessage = this.$t("MPRS-02-02-15-15", { 1: this.$t("MPAY-02-01-25-09") });
      //   this.modalOpend = true;
      //   return;
      // }
      // if (this.acno4 == "" || this.acno4 == null) {
      //   this.modalMessage = this.$t("MPRS-02-02-15-15", { 1: this.$t("MPAY-02-01-25-09") });
      //   this.modalOpend = true;
      //   return;
      // }
      if (this.valid()) {
        this.inquryAcno = this.inquryAcno.concat(this.acno1, this.acno2, this.acno3, this.acno4);
        this.RBF0600C60Call();
      }
    },
    RBF0600C60Call() {
      this.RBF0600C60.request = {
        dmndPageNo: "00000",
        pageLineCnt: "00000",
        gridRowCnt: "00001",
        inquiryUserStupAcnDstcd1: "2", // 입출금계좌구분코드2 1:출금계좌, 2:입금계좌
        deviceType: "mobile",
        inDataGrid: [
          {
            inquryUserStupAcnDstcd2: "2", // 입출금계좌구분코드2 1:출금계좌, 2:입금계좌
            inquryAcno: this.inquryAcno, // 계좌번호
            inqurySerno: "1", // 일련번호
            inquryBrncoEcrypPwd: "", // 계좌비밀번호
            inquryAcnAls: this.inquryAcnAls, // 계좌별명
            inquryDpstrName: this.inquryDpstrName, // 예금주명
            // inquryOthrBnkName: this.bnkEngName, // 타은행명
            inquryOthrBnkName: "", // 타은행명
            inquryBrnName: "", // 부점명
            inquryCncycd: this.cncycd, //통화코드
            inquryPrcssDstcd: "2", // 처리구분코드 1:출금계좌등록, 2:입금계좌등록, 5:계좌번호변경, 6:계좌번호해지
            inquryObaobDstcd: "2", // 당타행구분코드 1:당행, 2:타행
            draweAcitmDstcd: "01",
            rcevnBnkIfscCode: "",
          },
        ],
      };

      this.$post(
        "/customer/acn/MnrcyAcnRegiRes",
        this.RBF0600C60.request, //input값 요청할데이터
        this.RBF0600C60Suc, //호출 성공시 실행하는 콜백
        this.RBF0600C60Fail,
      );
    },
    RBF0600C60Suc(res) {
      this.RBF0600C60.response = res.outItem;
      this.$router.push({ name: "managePayeesList", params: { currentTab: 1 } });
    },
    RBF0600C60Fail() {
      this.inquryAcno = "";
    },
    setText(str) {
      this.$log.info(str);
      let acno = str.acno;
      if (!_.isEmpty(str.acno)) {
        this.acno1 = acno.substring(0, 2);
        this.acno2 = acno.substring(2, 6);
        this.acno3 = acno.substring(6, 13);
        this.acno4 = acno.substring(13, 15);
      }
    },
  },
};
</script>